import { Typography } from "@mui/material";
import { useListContext } from "react-admin";
import NoResults from "./NoResults";

const CustomLoading = () => {
  const { total, data, isPending, isLoading, isFetching } = useListContext();
  if (isPending)
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid">
        pending...
      </Typography>
    );
  if (isFetching)
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid">
        loading ...
      </Typography>
    );
  if (!total || total === 0) {
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid no-results">
        <NoResults />
      </Typography>
    );
  }
};

export default CustomLoading;
